import type { IState } from './models';

export const DEFAULT_STATE: IState = {
    view: 'form',
};

export const showForm = {
    focusEnabled: true,
    view: 'form' as const,
};

export const showDraft = {
    focusEnabled: false,
    view: 'refill' as const,
};

export const showPilApprovedLoan = {
    focusEnabled: false,
    view: 'approvedLoan' as const,
};

export const showPilPreapprovedOffers = {
    focusEnabled: false,
    view: 'preapprovedOffers' as const,
};
